import React from 'react'
import { BrowserRouter } from 'react-router-dom';
import AllRoutes from "./routes/AllRoutes";
import useRefreshStoredUser from "./hook/useRefreshStoredUser";

const App = () => {
  useRefreshStoredUser();

  return (
    <BrowserRouter>
      <AllRoutes />
    </BrowserRouter>
  );
}

export default App;
